export default function(name) {
  return (document.querySelector(`meta[name=${name}]`) || {}).content;
}
